import type { FC } from "react";
import {
  Card,
  Chip,
  Flex,
  Icon,
  Placeholder,
  Spacing,
  Text,
} from "@huub-web/ui";
import { rem } from "@huub-web/utils";

import type { AnalysisObservation as AnalysisObservationType } from "../../../types";

import { firstLetterCapitalStyle } from "../AnalysisObservationsSection.css";

export type AnalysisObservationProps = {
  observation?: AnalysisObservationType;
  disabled?: boolean;
  loading?: boolean;
  title?: string;
  onClick?: () => void;
};

export const AnalysisObservation: FC<AnalysisObservationProps> = ({
  observation,
  disabled = false,
  loading = false,
  title,
  onClick,
}) => (
  <Card border="default" onClick={onClick} disabled={disabled}>
    {loading ? (
      <>
        <Flex gap="xs" justify="space-between">
          <Text bold as="h4" ellipsis>
            {title}
          </Text>
          <Icon icon="loading" size="s" animation="rotation" />
        </Flex>
        <Flex gap="xs" wrap>
          <Placeholder
            height={rem(16)}
            width="20%"
            size="xs"
            variant="loading"
          />
          <Placeholder
            height={rem(16)}
            width="70%"
            size="xs"
            variant="loading"
          />
          <Placeholder
            height={rem(16)}
            width="40%"
            size="xs"
            variant="loading"
          />
          <Placeholder
            height={rem(16)}
            width="20%"
            size="xs"
            variant="loading"
          />
        </Flex>
        <Spacing height="xxl" />
      </>
    ) : (
      <>
        <Text bold as="h4" ellipsis className={firstLetterCapitalStyle}>
          {observation?.component?.replace(/_/g, " ")}
        </Text>
        <Text
          variant="surfaceSubtitle"
          className={firstLetterCapitalStyle}
          color="currentColor50"
        >
          {observation?.subCategoryName?.replace(/_/g, " ")}
        </Text>
        <Text variant="bodyS" markdown clamp={4} grow color="currentColor50">
          {observation?.explanation}
        </Text>
        <Chip
          variant="tertiary"
          className={firstLetterCapitalStyle}
          shrink={false}
          alignSelf="flex-start"
        >
          {observation?.assessment?.replace(/_/g, " ")}
        </Chip>
      </>
    )}
  </Card>
);
